import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import NativeSelectInput from '../../../../components/shared/components/NativeSelectInput';
import InputBase from '@material-ui/core/InputBase';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import '../CompanySignUp.css';
import { influenceInterests } from '../../../../constants';
import ChipInput from 'material-ui-chip-input';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  targetAudience: {
    marginTop: '35px',
    width: '90%',
    textAlign: 'center'
  },
  influencerInterestsContainer: {
    width: '100%',
    textAlign: 'center'
  },
  influencerInterests: {
    width: '80%'
  },
  influencer: {
    width: '100%',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  influencerMenu: {
    maxHeight: 0,
    '& .MuiPopover-paper': {
      minHeight: 250
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  titleContainer: {
    textAlign: 'center'
  }
});

class InfluenceInterest extends React.Component {
  constructor() {
    super();

    this.initialState = {
      submitAttempted: false,
      audienceError: '',
      interestsError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNextClick = () => {
    this.setState({
      submitAttempted: true
    });

    if (
      !this.props.companyInfo.interests ||
      !this.props.companyInfo.interests.length
    ) {
      this.setState({
        interestsError: 'Please enter at least one interest.'
      });
    } else {
      this.setState({
        interestsError: ''
      });
    }

    if (!this.props.companyInfo.targetAudience) {
      this.setState({
        audienceError: 'Please enter your target audience.'
      });
    } else {
      this.setState({
        audienceError: ''
      });
    }

    if (
      this.props.companyInfo.interests &&
      this.props.companyInfo.interests.length &&
      this.props.companyInfo.targetAudience
    ) {
      this.props.handleNext();
    }
  };

  render() {
    const {
      classes,
      companyInfo,
      changeHandler,
      interestChange,
      interestDelete,
      handleBack
    } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          spacing={40}
          alignItems="center"
          justify="center"
          direction="column"
        >
          <Grid
            item
            xs={12}
            sm={12}
            className={classes.influencerInterestsContainer}
          >
            <div className={classes.titleContainer}>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                display="inline"
              >
                Influencer interests
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Enter a couple terms that describe your desired influencer content (Fortnight, Devices, DOTA, etc.).'
                }
              />
            </div>
            <ChipInput
              value={companyInfo.interests}
              className={classes.influencerInterests}
              onChange={interestChange}
              color="primary"
              placeholder="type and press enter to add"
              alwaysShowPlaceholder={false}
              error={
                this.state.submitAttempted && this.state.interestsError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.interestsError : ''
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} className={classes.targetAudience}>
            <div className={classes.titleContainer}>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                display="inline"
              >
                Our target audience is
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'Enter a short description of the audience you generally target.'
                }
              />
            </div>
            <TextField
              id="targetAudience"
              name="targetAudience"
              className="mission-input"
              margin="normal"
              variant="outlined"
              onChange={changeHandler}
              error={
                this.state.submitAttempted && this.state.audienceError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.audienceError : ''
              }
            />
            <Typography
              variant="subtitle2"
              gutterBottom
              align="center"
              className="mission-helper-text"
              color="textSecondary"
            >
              Example: <br />
              18-25 year old who plays fantasy MMO's
              <br /> UK citizen who loves gluten-free food
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button onClick={handleBack} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNextClick.bind(this)}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(InfluenceInterest);



// WEBPACK FOOTER //
// ./src/components/sign-up/company/components/InfluenceInterest.js